<template>
  <div class="add-con">
    <van-form @submit="onSubmit">
      <van-field
        v-model="orderID"
        label="订单单号"
        placeholder="请输入订单单号"
        required
        :rules="[{ required: true, message: '请输入订单单号' }]"
      />
      <div class="addBut">
        <van-button
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          round
          block
          type="info"
          native-type="submit"
        >提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import { Toast } from 'vant'
import URLTB from "@/api/apiTB";
export default {
  data() {
    return {
     orderID:'', 
    }
  },
  mounted() {
  },
  methods: {
    onSubmit() {
      let data={
        orderId:this.orderID,
        orderType:'loan'
      }
      this.$fetchPost(URLTB.addOrder.url, data).then(res=>{
        if(res.data.code==20000){
          Toast(res.data.msg)
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.add-con {
  height: 100vh;
  background: #ffffff;
  overflow: scroll;
  position: relative;
  .van-cell{
    width: 355px;
    height: 40px;
    margin: auto;
  }
  .addBut {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 36px;
    width: 273px;
    margin: 76px auto 20px;
  }
}
</style>